// services/ExamIncidentService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Liste/creation uniquement : un incident consigné (PV numérique) n'est
// jamais modifié ni supprimé une fois créé (traçabilité).
export function getExamIncidents(params = {}) {
    return api.get(ENDPOINTS.EXAM_INCIDENTS.BASE, { params });
}
export function getExamIncidentById(id) {
    return api.get(ENDPOINTS.EXAM_INCIDENTS.BY_ID(id));
}
export function createExamIncident(payload) {
    return api.post(ENDPOINTS.EXAM_INCIDENTS.BASE, payload);
}
// PV imprimable/signable (PDF) - réponse binaire, pas de parsing JSON.
export function downloadExamIncidentPv(id) {
    return api.get(`${ENDPOINTS.EXAM_INCIDENTS.BY_ID(id)}/pv`, { responseType: "blob" });
}
